import React from "react";
import { Link } from "react-router-dom";

const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-[#0A0A0A] text-gray-300 font-sans selection:bg-[#00FF41] selection:text-black">
    {/* Navigation */}
    <nav className="border-b border-white/5 bg-black/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-3 group">
          <div className="w-10 h-10 bg-gradient-to-br from-[#00FF41] to-[#008F22] rounded-xl flex items-center justify-center group-hover:rotate-12 transition-transform duration-300 shadow-[0_0_20px_rgba(0,255,65,0.2)]">
            <span className="text-black font-black text-xl">NR</span>
          </div>
          <span className="text-xl font-bold tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
            NORESPECT<span className="text-[#00FF41]">DIGITAL</span>
          </span>
        </Link>
        <Link to="/" className="text-sm font-medium hover:text-[#00FF41] transition-colors">
          Back to Home
        </Link>
      </div>
    </nav>

    <div className="max-w-4xl mx-auto px-6 py-20">
      <div className="space-y-8">
        <h1 className="text-5xl font-black text-white tracking-tight uppercase">
          {title}
        </h1>
        <div className="text-gray-400 space-y-4">
          {children}
        </div>
      </div>
    </div>

    <footer className="border-t border-white/5 py-12 bg-black">
      <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} NoRespectDigital. All rights reserved.
      </div>
    </footer>
  </div>
);

const Terms = () => {
  return (
    <LegalLayout title="Terms of Service">
      <section className="space-y-6">
        <p className="text-lg leading-relaxed">
          Welcome to NoRespectDigital. By accessing or using our website and B2B automation tools, you agree to be bound by these Terms of Service.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">1. Agreement to Terms</h2>
        <p>
          These Terms constitute a legally binding agreement made between you and NoRespectDigital regarding your access to and use of our platform. We provide specialized B2B lead generation, inventory management, and security automation software.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">2. Intellectual Property Rights</h2>
        <p>
          Unless otherwise indicated, the Site and Services are our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site are owned or controlled by us.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">3. User Representations</h2>
        <p>
          By using our services, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information; (3) you have the legal capacity and you agree to comply with these Terms of Service.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">4. Fees and Payment</h2>
        <p>
          We use Paddle as our primary payment gateway. You agree to pay all charges at the prices then in effect for your purchases and any applicable shipping fees, and you authorize us to charge your chosen payment provider through Paddle for any such amounts.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">5. Prohibited Activities</h2>
        <p>
          You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">6. Limitation of Liability</h2>
        <p>
          In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages arising from your use of the site or services.
        </p>

        <p className="pt-10 text-sm italic">
          Last updated: April 15, 2026
        </p>
      </section>
    </LegalLayout>
  );
};

export default Terms;
